var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClickHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 38.3335H7.66667V43.0002H3V38.3335Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.6665H7.66667V38.3332H3V5.6665Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 5.6665H16.9999V42.9998H12.3333V5.6665Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 5.6665H26.3334V42.9998H21.6667V5.6665Z",
    fill: "#FFCC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 5.6665H35.6667V42.9998H31V5.6665Z",
    fill: "#FFCC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 20.8335H44.9999V27.8335H40.3333V20.8335Z",
    fill: "#FFCC00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickHouse);
export default __webpack_public_path__ + "static/media/ClickHouse.7aada5a3.svg";
export { ForwardRef as ReactComponent };